import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { CardHeader, Typography, Button } from "@mui/material";

const CardContainer = (props) => {
    const { title, height, children, contentOnCenter, actions, isOutlined, px, m, py, pb } = props;
    return (
        <Card
            variant={isOutlined ? "outlined" : ""}
            sx={{
                px: px,
                py: py,
                m: m,
                pb: pb,
                height: { xl: height, lg: height, sm: "auto", xs: "auto" },
            }}>
            {title ? (
                <CardHeader
                    title={title}
                    titleTypographyProps={{}}
                    sx={{
                        borderBottom: "1px solid #E8E8E8",
                        px: 0,
                        py: 1,
                        mb: { xs: 2, md: 2, sm: 6 },
                    }}
                />
            ) : (
                <></>
            )}
            <CardContent sx={{ height: "96%", overflow: "scroll" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: contentOnCenter ? "center" : "flex-start",
                    }}>
                    {children}
                </Box>
            </CardContent>
            {actions ? (
                <CardActions
                    sx={{
                        height: "18px",
                        px: 0,
                        mb: { xs: 2, md: 2, sm: 6, lg: 6, xl: 6 },
                    }}>
                    {actions}
                </CardActions>
            ) : (
                <></>
            )}
        </Card>
    );
};

export { CardContainer };
